import * as types from '../actions/action-types';

export const initialState = {
  sessionData: null,
};

export default function opttyReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_OPTTY_SESSION_DATA: {
      return {
        ...state.optty,
        sessionData: action.sessionData,
      };
    }
    default:
      return state;
  }
}
